import { useState } from "react";
import styled from "styled-components";

import { translate } from "@utils";
import styles from "./shared.css";

import { ModalBox } from "@shared/components";

import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";

export const ConfirmAction = ({
	open,
	setOpen,
	children,
	onConfirmed,
	onCanceled,
	confirmButtonText = translate("confirm_delete_button"),
	cancelButtonText = translate("phrase_cancel"),
	message = <h5>{translate("confirm_delete_message")}</h5>,
	parentProps,
}) => {
	const [openModal, setOpenModal] = useState(open);
	const isControlled = Boolean(setOpen);

	const onCancel = () => {
		isControlled ? setOpen(false) : setOpenModal(false);
		if (onCanceled) onCanceled();
	};

	const onConfirm = () => {
		isControlled ? setOpen(false) : setOpenModal(false);
		onConfirmed();
	};

	return (
		<div onClick={isControlled ? () => setOpen(true) : () => setOpenModal(true)} {...parentProps}>
			{children}
			<Modal open={isControlled ? open : openModal} onClose={onCancel} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
				<ModalBox className={styles.confirmActionModalBox}>
					<div style={{ textAlign: "center", marginBottom: "40px" }}>{message}</div>
					<div className={styles.confirmActionButtonsGroup}>
						<Button color="secondary" className={styles.confirmActionBtns} onClick={onCancel}>
							{cancelButtonText}
						</Button>
						<Button color="error" className={styles.confirmActionBtns} onClick={onConfirm}>
							{confirmButtonText}
						</Button>
					</div>
				</ModalBox>
			</Modal>
		</div>
	);
};
